import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  dataBlog: []
});

let result = '';

const dataBlog = (state = defaultState, action) => {
  switch (action.type) {
    case types.GET_LIST_BLOG_RESULT:
      result = action.payload;
      return state.set('dataBlog', result);

    default:
      return state;
  }
};

export default dataBlog;
